import { render, staticRenderFns } from "./home-configuration.vue?vue&type=template&id=01963418&"
import script from "./home-configuration.vue?vue&type=script&lang=js&"
export * from "./home-configuration.vue?vue&type=script&lang=js&"
import style0 from "./home-configuration.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports